<wl-partial-card
  class="card--fixed-overlay"
  [divider]="!!title?.value"
  wlDisableBodyScrolling
>
  <ng-container slot="header">
    @if (!!title?.value) {
      <wl-modal-page-header
        [title]="title"
        [href]="href"
        [navigationExtras]="navigationExtras"
        (closeFunction)="closeFunction.emit()"
        [isButton]="isButton()"
      ></wl-modal-page-header>
    }
  </ng-container>
  <ng-container slot="content">
    <div class="mb-3">
      <ng-content select="form"></ng-content>
    </div>
    <div
      class="d-block d-md-flex justify-content-between align-items-center flex-column flex-md-row"
      role="group"
    >
      <div class="flex-grow-1 flex-md-grow-0 order-0 order-md-1 mb-2 mb-md-0">
        <ng-content select="action-button"></ng-content>
      </div>
      <div class="flex-grow-1 flex-md-grow-0 order-1 order-md-0">
        <ng-content select="cancel-button"></ng-content>
      </div>
    </div>
  </ng-container>
</wl-partial-card>
